module.exports = __webpack_public_path__ + "static/media/user-nft-4.32fb02d4.jpg";